// extracted by css-extract-rspack-plugin
export default {"root":"DKQzjb","thumb":"ltqpy9","title":"sDC_Ac","product-type":"OCYjwF","productType":"OCYjwF"};